import { FC } from "react";
import GoogleLogoSVG from "../../resources/svg/logos/GoogleLogoSVG";
import CustomInput from "../../../custom-components/form-inputs/CustomInput";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import CustomError from "../../../custom-components/form-inputs/CustomError";
import { UserRegistrationFirstStep } from "../../../domain/models/dto/UserDTO";
import { userRegistrationFirstStepFields } from "../../../validation-schemas/user-schemas/UserRegistrationSchema";
import PasswordInput from "../../resources/components/form-inputs/PasswordInput";
import { useGoogleLogin } from "@react-oauth/google";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { UserServiceImpl } from "../../../services/UserServiceImpl";
import { useNavigate } from "react-router-dom";

interface RegistrationFirstStepFormProps {
    form: FormikProps<UserRegistrationFirstStep>;
    error: string;
}

const RegistrationFirstStepForm: FC<RegistrationFirstStepFormProps> = (props) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const googleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            const result = await dispatch(
                UserServiceImpl.googleLoginThunk({ code: tokenResponse.code })
            );
            if (result.meta.requestStatus === "fulfilled") {
                navigate("/");
            }
        },
        flow: "auth-code",
    });

    return (
        <div className="relative w-full">
            <p className="H20 dmax2:H14 text-textFaded text-center mb-[50px] dmax2:mb-6">
                {t("registration.step1Name")}
            </p>
            <div
                onClick={() => googleLogin()}
                className="button H20 dmax2:H16 bg-backgroundButton hover:bg-backgroundInput w-full h-[60px] dmax2:h-[45px] mb-8 dmax2:mb-6 transition-all duration-300 cursor-pointer"
            >
                <div className="mb-[2px] dmax2:mb-[1px]">{t("registration.registrationAlt")}</div>
                <GoogleLogoSVG className="ml-4 dmax2:w-6 dmax2:h-6" />
            </div>
            <CustomInput
                form={props.form}
                name="email"
                fields={userRegistrationFirstStepFields}
                className="w-full h-[63px] dmax2:h-[45px] mb-3 dmax2:mb-2"
            />
            <PasswordInput form={props.form} name="password" fields={userRegistrationFirstStepFields} />
            <PasswordInput form={props.form} name="confirmPassword" fields={userRegistrationFirstStepFields} />
            <div className="mt-8">
                <CustomError form={props.form} errorKey={props.error || ""} className="mb-4 text-center" />
                <div
                    onClick={() => props.form.handleSubmit()}
                    className="button H20 dmax2:H14B w-full h-[60px] dmax2:h-[45px] cursor-pointer transition-all duration-300"
                >
                    <div className="mb-[2px] dmax2:mb-[1px]">{t("common.next")}</div>
                </div>
            </div>
        </div>
    );
};

export default RegistrationFirstStepForm;
